import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useIsCompactMode } from '@frontend/responsiveness';
import { taskCenterTrackingIds } from '@frontend/task-center-components';
import { theme } from '@frontend/theme';
import { Chip, Text, usePopoverDialog } from '@frontend/design-system';
import { getAssigneeDetails } from '../../utils';
import { TaskAssigneeFilter } from '../filters/task-assignee-filter/task-assignee-filters';

interface TaskAssigneeDropdownProps {
  assignees: any[];
  assigneeFilter: string;
  setAssigneeFilter: (value: string) => void;
}

export const TaskAssigneeDropdown = ({ assignees, assigneeFilter, setAssigneeFilter }: TaskAssigneeDropdownProps) => {
  const { t } = useTranslation('task-center');
  const isCompactMode = useIsCompactMode();
  const { name: assignee, AvatarComponent } = getAssigneeDetails(assignees, assigneeFilter);
  const popoverDialogProps = usePopoverDialog();

  return (
    <span css={{ display: 'flex', marginLeft: theme.spacing(1.5), alignItems: 'center', gap: theme.spacing(0.5) }}>
      {!isCompactMode && (
        <Text size='medium' weight='regular'>
          {t('Assigned To:')}
        </Text>
      )}
      <Chip.StatusSwitcher
        variant='neutral'
        // @ts-expect-error Right element prop does not exists in the chip, but is available as it extending Chip
        rightElement={<Icon name='caret-down-small' size={12} />}
        css={css`
          border: none;
          max-width: 100%;
          padding: ${theme.spacing(2.25, 1)};
        `}
        {...popoverDialogProps.getTriggerProps()}
        trackingId={taskCenterTrackingIds.filters.assigneeFilter}
      >
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(0.5) }}>
          {AvatarComponent && <AvatarComponent />}
          <Text css={{ maxWidth: '90px', overflow: 'hidden', textOverflow: 'ellipsis' }} size='small'>
            {assignee}
          </Text>
        </div>
      </Chip.StatusSwitcher>
      {popoverDialogProps.isOpen && (
        <TaskAssigneeFilter
          setValue={(value: string) => {
            setAssigneeFilter(value);
            popoverDialogProps.close();
          }}
          selectedValue={assigneeFilter}
          getDialogProps={popoverDialogProps.getDialogProps}
        />
      )}
    </span>
  );
};
